import { render, staticRenderFns } from "./StartupFundingRequest.vue?vue&type=template&id=62b3a234&scoped=true&"
import script from "./StartupFundingRequest.vue?vue&type=script&lang=js&"
export * from "./StartupFundingRequest.vue?vue&type=script&lang=js&"
import style0 from "./StartupFundingRequest.vue?vue&type=style&index=0&id=62b3a234&scoped=true&lang=css&"
import style1 from "./StartupFundingRequest.vue?vue&type=style&index=1&id=62b3a234&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b3a234",
  null
  
)

export default component.exports